import { render, staticRenderFns } from "./OnboardingContributionScheduledMessage.vue?vue&type=template&id=7707e798"
import script from "./OnboardingContributionScheduledMessage.vue?vue&type=script&lang=ts"
export * from "./OnboardingContributionScheduledMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports